import React from "react";

import ContentLayout from "Components/ContentLayout";
import PageMeta from "Components/PageMeta";

import MetricsErrorBoundary from "../components/ErrorBoundary";
import useMetricsLinkData from "../hooks/useMetricsLinkData";

import View from "./View2";

const Page = () => {
  const { deploymentType, href, type, collection } = useMetricsLinkData();

  return href ? (
    <MetricsErrorBoundary>
      <ContentLayout>
        <PageMeta title="Metrics" />

        <View
          // deploymentType exposed on Git15; fall back to metrics link type for older versions of Git
          type={deploymentType || type}
          href={href}
          collection={collection}
        />
      </ContentLayout>
    </MetricsErrorBoundary>
  ) : null;
};

export default React.memo(Page);
